import React from 'react';
import { Select } from 'antd';
import { useTaskDrawer } from '../TaskDrawerContext';
import { getFullName } from '../utils/personUtils';
import Avatar from './Avatar';

export default function TaskReviewers() {
    const { reviewers, availableReviewers, handleAddReviewer, handleRemoveReviewer } = useTaskDrawer();

    return (
        <section className="space-y-3 pt-4 border-t border-surface-container-high">
            <div className="flex items-center justify-between">
                <label className="font-bold text-on-surface">Reviewers</label>
                {availableReviewers.length > 0 && (
                    <Select
                        placeholder="Add reviewer..."
                        onChange={handleAddReviewer}
                        value={null}
                        className="w-48 text-xs"
                        showSearch
                        optionFilterProp="label"
                    >
                        {availableReviewers.map((employee) => (
                            <Select.Option key={employee._id} value={employee._id} label={getFullName(employee)}>
                                <div className="flex items-center gap-2">
                                    <Avatar person={employee} size={18} />
                                    <span className="text-xs">{getFullName(employee)}</span>
                                </div>
                            </Select.Option>
                        ))}
                    </Select>
                )}
            </div>
            <div className="flex flex-wrap gap-2">
                {reviewers.map((reviewer) => {
                    const name = getFullName(reviewer);
                    return (
                        <div
                            key={reviewer._id || reviewer}
                            className="inline-flex items-center gap-1.5 bg-[#f59e0b]/10 px-3 py-1 rounded-full text-xs font-medium text-[#b45309]"
                        >
                            <Avatar person={reviewer} size={16} />
                            <span className="truncate max-w-[120px]" title={name}>
                                {name}
                            </span>
                            <button
                                onClick={() => handleRemoveReviewer(reviewer._id || reviewer)}
                                className="hover:text-error font-bold ml-1 text-sm flex items-center"
                            >
                                x
                            </button>
                        </div>
                    );
                })}
                {reviewers.length === 0 && (
                    <span className="text-xs text-on-surface-variant opacity-60 italic">No reviewers assigned yet</span>
                )}
            </div>
        </section>
    );
}

